// extracted by mini-css-extract-plugin
module.exports = {"appDownloadLoader":"sRwBQ63BS2Wb2e1h8Ab_Y"};